import { panelChatPayload } from "../infrastructure/panel-chat-connection.js";

/** Loads every admin booth page, including booths without a prior conversation. */
export async function loadAdminChatBooths(token, signal) {
  const booths = [];
  let page = 1;
  let totalPages = 1;
  do {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/v2/Booth/GetAll?Page=${page}&Limit=100`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      signal
    });
    if (response.status === 403) return [];
    if (!response.ok) throw new Error("دریافت لیست غرفه‌ها ناموفق بود.");
    const payload = panelChatPayload(await response.json());
    if (payload.code !== 200 || !Array.isArray(payload.data)) throw new Error("پاسخ لیست غرفه‌ها معتبر نیست.");
    booths.push(...payload.data);
    totalPages = Number(payload.meta?.total_pages || 1);
    page++;
  } while (page <= totalPages);
  return booths;
}

/** Joins booths with existing chats without creating conversations on read. */
export function mergeBoothContacts(booths, chats, currentUserId) {
  const matchedChatIds = new Set();
  const contacts = booths.map(booth => {
    const chat = chats.find(item => Number(item.userId) === Number(booth.userId) && Number(booth.userId) > 0);
    if (chat) matchedChatIds.add(chat.id);
    return {
      ...chat,
      key: `booth-${booth.id}`,
      boothId: booth.id,
      boothTitle: booth.title,
      boothGalleryId: booth.logo,
      userId: booth.userId,
      boothMessage: true,
      canChat: Number(booth.userId) > 0 && Number(booth.userId) !== Number(currentUserId)
    };
  });
  for (const chat of chats) {
    if (!matchedChatIds.has(chat.id)) contacts.push({
      ...chat,
      key: `chat-${chat.id}`,
      canChat: true
    });
  }
  return contacts;
}

/** Creates or reopens a conversation with the actual booth owner through the admin API. */
export async function openAdminBoothChat(token, contact, signal) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/v2/Chat/Insert`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      targetUserId: Number(contact.userId)
    }),
    signal
  });
  if (!response.ok) throw new Error("شروع گفتگو با صاحب غرفه ناموفق بود.");
  const payload = panelChatPayload(await response.json());
  if (payload.code !== 200 || !(payload.data?.id > 0)) throw new Error("پاسخ گفتگو معتبر نیست.");
  return {
    ...contact,
    id: payload.data.id
  };
}
